import { Controller } from "@hotwired/stimulus";

// Controller: help
// Manages the help widget toggle with full keyboard accessibility.
// Handles open/close, focus management, escape key, and click-outside-to-close.
export default class extends Controller {
  static targets = ["trigger", "bubble"];

  connect() {
    this.boundHandleClickOutside = this.handleClickOutside.bind(this);
    this.boundHandleKeydown = this.handleKeydown.bind(this);
  }

  disconnect() {
    this.removeGlobalListeners();
  }

  toggle(event) {
    event.stopPropagation();
    if (this.isOpen) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    this.element.classList.add("help--active");
    this.triggerTarget.setAttribute("aria-expanded", "true");
    this.addGlobalListeners();
  }

  close() {
    this.element.classList.remove("help--active");
    this.triggerTarget.setAttribute("aria-expanded", "false");
    this.removeGlobalListeners();
  }

  closeAndFocus(event) {
    event.stopPropagation();
    this.close();
    this.triggerTarget.focus();
  }

  get isOpen() {
    return this.element.classList.contains("help--active");
  }

  addGlobalListeners() {
    document.addEventListener("click", this.boundHandleClickOutside);
    document.addEventListener("keydown", this.boundHandleKeydown);
  }

  removeGlobalListeners() {
    document.removeEventListener("click", this.boundHandleClickOutside);
    document.removeEventListener("keydown", this.boundHandleKeydown);
  }

  handleClickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.close();
    }
  }

  handleKeydown(event) {
    if (event.key === "Escape" && this.isOpen) {
      this.close();
      this.triggerTarget.focus();
    }
  }
}
